import styled from 'styled-components';

export const StyledProduct = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;
  width: 100%;

  img {
    height: 235px;
    object-fit: contain;
    filter: drop-shadow(0 0 0.75rem rgb(255, 255, 255, 0.5));
  }
` as any;

export const StyledProductText = styled.div`
  font-size: 24px;
  color: ${(props: any) => props.color};
  font-weight: bold;
  text-shadow: 1px 1px 3px #693510, -1px -1px 3px #693510, 1px -1px 3px #693510,
    -1px 1px 3px #693510;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-top: 8px;
  margin-right: 5px;
  width: 100%;

  &:last-child {
    margin-right: 0;
  }

  img {
    height: 20px;
    width: 20px;
  }

  .quantity-wrapper {
    max-width: calc(100% - 24px);
  }
`;
